import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "../../../build/public/globals.css";
import "react-photo-album/rows.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { use } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider, useTranslation } from "react-i18next";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { createFromFetch } from "react-server-dom-webpack/client";
import { i18next } from "./i18n/i18n";
import { resolveLocale } from "./i18n/resolveLocale";
const documentRoot = document.getElementById("root");
if (!documentRoot) {
    throw new Error("couldn't find root element");
}
const root = createRoot(documentRoot);
root.render(_jsx(I18nextProvider, { i18n: i18next, children: _jsx(Root, {}) }));
const cache = new Map();
function Root() {
    const homeRoute = process.env.SLIDESHOW_BASE_PATH || "";
    const query = new URLSearchParams(window.location.search);
    const locale = resolveLocale(query.get("locale") || window.navigator.language);
    void i18next.changeLanguage(locale);
    const { t } = useTranslation();
    if (window.location.pathname === homeRoute) {
        return (_jsxs("div", { children: [_jsx("h1", { children: t("notFound.title") }), _jsx("p", { children: t("notFound.message", { homeRoute }) })] }));
    }
    query.set("locale", locale);
    const path = window.location.pathname.slice(homeRoute.length);
    const fetchLocation = `${homeRoute}/react${path}?${query.toString()}`;
    let content = cache.get(fetchLocation);
    if (!content) {
        content = createFromFetch(fetch(fetchLocation));
        cache.set(fetchLocation, content);
    }
    return _jsx(_Fragment, { children: use(content) });
}
